import {
  IPrice,
} from "../../../modules/settings/types";

export const settingsConstants = {
  PricesFetchAll: "PRICES_FETCH_ALL",
  };

export interface ISettingsState {
  priceList?: IPrice[];
}

const initialState: ISettingsState = {
  priceList: []
};

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case settingsConstants.PricesFetchAll: {
      return { ...state, priceList: action.payload };
    }

    default: {
      return state;
    }
  }
}
